import React from "react";
import { Lock } from "lucide-react";

/** Lock medallion on the outline corner — matches physics-disabled icon buttons in context rows. */
export default function PhysicsOutlineLockBadge({ className = "" }) {
  return (
    <span
      className={[
        "pointer-events-none absolute -right-1 -top-1 z-[1] inline-flex h-4 w-4 items-center justify-center rounded-full border border-amber-300/80 bg-[rgb(40,40,40)] text-amber-200 shadow-sm",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      aria-hidden="true"
    >
      <Lock className="h-2.5 w-2.5" aria-hidden="true" />
    </span>
  );
}
